import { render, staticRenderFns } from "./signUserInWithPhone.vue?vue&type=template&id=8fa2e122"
import script from "./signUserInWithPhone.vue?vue&type=script&lang=js"
export * from "./signUserInWithPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports